import React from 'react';
import { reportError } from '../utils/errorReporting';

// Vangt renderfouten op die anders een wit scherm geven, meldt ze (utils/errorReporting.js) en
// toont een rustige melding met een knop om te herladen. Staat buiten de IntlProvider, dus de
// teksten staan hier zelf in twee talen.
const TEKSTEN = {
    nl: {
        titel: 'Er ging iets mis',
        uitleg: 'Onze excuses, deze pagina kon niet getoond worden. Probeer de pagina te herladen. Blijft het misgaan, probeer het dan later opnieuw.',
        knop: 'Pagina herladen'
    },
    en: {
        titel: 'Something went wrong',
        uitleg: 'Sorry, this page could not be displayed. Please try reloading the page. If it keeps failing, try again later.',
        knop: 'Reload page'
    }
};

function taal() {
    try {
        const opgeslagen = localStorage.getItem('language');
        if (opgeslagen === 'nl' || opgeslagen === 'en') return opgeslagen;
    } catch {
        // geen opslag beschikbaar
    }
    return (navigator.language || '').toLowerCase().startsWith('nl') ? 'nl' : 'en';
}

// Na een nieuwe uitrol bestaan de oude, gehashte bestanden niet meer: een geopend tabblad
// dat dan een pagina nalaadt krijgt een "ChunkLoadError". Eén keer automatisch herladen
// haalt de nieuwe versie op (de vlag voorkomt een eindeloze herlaadlus).
function isStaleBundleError(error) {
    const text = `${(error && error.name) || ''} ${(error && error.message) || ''}`;
    return /ChunkLoadError|Loading chunk .* failed|Loading CSS chunk|Failed to fetch dynamically imported module/i.test(text);
}

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { error: null };
    }

    static getDerivedStateFromError(error) {
        return { error };
    }

    componentDidCatch(error) {
        if (isStaleBundleError(error)) {
            try {
                if (!sessionStorage.getItem('chunk-reload')) {
                    sessionStorage.setItem('chunk-reload', '1');
                    window.location.reload();
                    return;
                }
            } catch {
                // zonder sessionStorage tonen we gewoon de melding
            }
        }
        reportError(error, 'boundary');
    }

    render() {
        if (!this.state.error) return this.props.children;
        const t = TEKSTEN[taal()];
        return (
            <div role="alert" style={{ maxWidth: 480, margin: '15vh auto', padding: '0 20px', textAlign: 'center', fontFamily: 'system-ui, sans-serif', color: '#222' }}>
                <h1 style={{ fontSize: '1.4rem', marginBottom: 12 }}>{t.titel}</h1>
                <p style={{ lineHeight: 1.5, marginBottom: 24 }}>{t.uitleg}</p>
                <button
                    type="button"
                    onClick={() => window.location.reload()}
                    style={{ padding: '10px 22px', fontSize: '1rem', borderRadius: 6, border: 'none', background: '#007bff', color: '#fff', cursor: 'pointer' }}
                >
                    {t.knop}
                </button>
            </div>
        );
    }
}

export default ErrorBoundary;
